import React, { useContext, useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import ModalCarta from "./ModalCarta";
import { useHistory } from "react-router-dom";
import CartaContext from "../../context/cartaContext/cartaContext";
import AdminContext from "../../context/adminContext/adminContext";
import AuthContext from "../../context/authContext/authContext";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MuiAlert from "@material-ui/lab/Alert";
import AddIcon from "@material-ui/icons/Add";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import clienteAxios from "../../config/axios";
import tokenAuth from "../../config/tokenAuth";
import {
  Container,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Typography,
  IconButton,
  CircularProgress,
  Backdrop,
  Snackbar,
  Fab,
  Modal,
  Fade,
  Button,
  LinearProgress,
  Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    textTransform: "capitalize",
  },
  tableContainer: {
    marginBottom: "2rem",
  },
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginLeft: "185%",
  },
  cirular: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginLeft: "285%",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  add: {
    position: "fixed",
    top: theme.spacing(10),
    right: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
    margin: theme.spacing(1),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  botonera: {
    display: "flex",
    justifyContent: "space-evenly",
    marginTop: "1rem",
  },
  input: {
    display: "none",
  },
  progress: {
    zIndex: 10000000,
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography
          variant="body2"
          color="textSecondary"
        >{`${props.value}%`}</Typography>
      </Box>
    </Box>
  );
}

const VerCarta = () => {
  const classes = useStyles();
  const history = useHistory();
  //CONTEXT
  const cartaContext = useContext(CartaContext);
  const { platos, ingredientes, bebidas, obtenerMenu } = cartaContext;
  const adminContext = useContext(AdminContext);
  const {
    error,
    mensaje,
    resetMensaje,
    confirmDelete,
    uploadCarta,
  } = adminContext;
  const authContext = useContext(AuthContext);
  const { cliente } = authContext;

  //STATE LOCALES
  const [value, setvalue] = useState(0);
  const [Delete, setDelete] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [item, setitem] = useState([]);
  const [newItem, setnewItem] = useState({
    tipo: "nada",
  });
  const [loading, setloading] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      obtenerMenu();
      if (cliente) {
        if (
          cliente.nombre === "mesera" ||
          cliente.nombre === "agus mesera" ||
          cliente.nombre === "mesera2"
        ) {
          history.push("/admin/salon");
        }
      }
    }
    return function cleanup() {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [openModal, mensaje]);
  //FUNCIONES LOCALES
  const editItem = (tipo, item) => {
    item.tipo = tipo;
    setitem(item);
    setopenModal(true);
  };
  const handleClose = () => {
    resetMensaje();
    setitem({});
    setDelete(false);
  };
  const borrarItem = (tipo, item) => {
    item.tipo = tipo;
    setitem(item);
    setDelete(true);
  };

  const delItem = (item) => {
    setloading(true);
    confirmDelete(item);

    setitem({});
    setnewItem({
      tipo: "nada",
    });
    setloading(false);
    setDelete(false);
  };
  const handleCarta = ({ target }) => {
    const dataForm = new FormData();
    if (target.files[0].name.split(".")[1] !== "pdf") {
      alert("El archivo no es un pdf");
    } else {
      dataForm.append("imagen", target.files[0]);

      const token = localStorage.getItem("token");
      const options = {
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let porcentaje = Math.floor((loaded * 100) / total);
          setvalue(porcentaje);
        },
      };
      if (token) tokenAuth(token);

      try {
        setloading(true);
        clienteAxios.post(`/api/upload`, dataForm, options).then((res) => {
          setloading(false);
          setvalue(0);

          uploadCarta(res.data.msg);
        });
      } catch (error) {
        setloading(false);
        setvalue(0);
        alert("Error al subir la carta");
      }
    }
  };

  return (
    <AdminLayout>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {value > 0 ? (
        <LinearProgressWithLabel value={value} className={classes.progress} />
      ) : null}

      <Snackbar
        open={mensaje ? true : false}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="success">
          {mensaje}
        </Alert>
      </Snackbar>
      <Snackbar
        open={error ? true : false}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="error">
          {mensaje}
        </Alert>
      </Snackbar>
      <div className={classes.add}>
        <Fab
          color="secondary"
          aria-label="add"
          onClick={() => setopenModal(true)}
        >
          <AddIcon />
        </Fab>
        <input
          accept="image/*"
          className={classes.input}
          id="icon-button-file"
          type="file"
          onChange={handleCarta}
        />
        <label htmlFor="icon-button-file">
          <IconButton
            color="secondary"
            aria-label="upload picture"
            component="span"
          >
            <MenuBookIcon />
          </IconButton>
        </label>
      </div>

      <Container maxWidth="md">
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={Delete}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={Delete}>
            <div className={classes.paper}>
              <Typography variant="h4" align="center">
                Desea eleminar {item.nombre}?
              </Typography>
              <div className={classes.botonera}>
                <Button variant="contained" onClick={() => handleClose()}>
                  No
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => delItem(item)}
                >
                  Si
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
        <ModalCarta
          openModal={openModal}
          setopenModal={setopenModal}
          item={item}
          setitem={setitem}
          setloading={setloading}
          setnewItem={setnewItem}
          newItem={newItem}
        />
        <Typography variant="h3" align="center">
          Carta
        </Typography>
        <Typography variant="h4" gutterBottom="true">
          Platos
        </Typography>
        <TableContainer className={classes.tableContainer} component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell align="right">Categoria</TableCell>
                <TableCell align="right">Precio</TableCell>
                <TableCell align="right">Stock</TableCell>
                <TableCell align="right">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {platos ? (
                platos.map((plato) => {
                  return (
                    <TableRow key={plato._id}>
                      <TableCell component="th" scope="row">
                        {plato.nombre}
                      </TableCell>
                      <TableCell align="right">{plato.categoria}</TableCell>
                      <TableCell align="right">${plato.precio}</TableCell>
                      <TableCell align="right">
                        {plato.stock ? "SI" : "NO"}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          aria-label="edit"
                          color="secondary"
                          onClick={() => editItem("plato", plato)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => borrarItem("plato", plato)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <div className={classes.root}>
                  <CircularProgress color="secondary" />
                </div>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="h4" gutterBottom="true">
          Ingredientes
        </Typography>
        <TableContainer className={classes.tableContainer} component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell align="right">Precio en Hamburguesa</TableCell>
                <TableCell align="right">Precio en Milanesa</TableCell>
                <TableCell align="right">Stock</TableCell>
                <TableCell align="right">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ingredientes ? (
                ingredientes.map((ingrediente) => {
                  return (
                    <TableRow key={ingrediente._id}>
                      <TableCell component="th" scope="row">
                        {ingrediente.nombre}
                      </TableCell>
                      <TableCell align="right">
                        ${ingrediente.precio_hamburguesa}
                      </TableCell>
                      <TableCell align="right">
                        ${ingrediente.precio_milanesa}
                      </TableCell>
                      <TableCell align="right">
                        {ingrediente.stock ? "SI" : "NO"}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          aria-label="edit"
                          color="secondary"
                          onClick={() => editItem("ingrediente", ingrediente)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => borrarItem("ingrediente", ingrediente)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <div className={classes.cirular}>
                  <CircularProgress color="secondary" />
                </div>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="h4" gutterBottom="true">
          Bebidas
        </Typography>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell align="right">Categoria</TableCell>
                <TableCell align="right">Precio</TableCell>
                <TableCell align="right">Stock</TableCell>
                <TableCell align="right">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bebidas ? (
                bebidas.map((bebida) => {
                  return (
                    <TableRow key={bebida._id}>
                      <TableCell component="th" scope="row">
                        {bebida.nombre}
                      </TableCell>
                      <TableCell align="right">{bebida.categoria}</TableCell>
                      <TableCell align="right">${bebida.precio}</TableCell>
                      <TableCell align="right">
                        {bebida.stock ? "SI" : "NO"}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          aria-label="edit"
                          color="secondary"
                          onClick={() => editItem("bebida", bebida)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => borrarItem("bebida", bebida)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <div className={classes.root}>
                  <CircularProgress color="secondary" />
                </div>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </AdminLayout>
  );
};

export default VerCarta;
